'use strict';

module.exports = {
  bundle: 'bundle',
  workpackage: 'workpackage',
  scenario: 'scenario',
  canvas: 'canvas',
  checkpoint: 'checkpoint',
};
